export const icons = {
  delete: (
    <path d="M10 5H14C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3C11.4696 3 10.9609 3.21071 10.5858 3.58579C10.2107 3.96086 10 4.46957 10 5ZM8.5 5C8.5 4.54037 8.59053 4.08525 8.76642 3.66061C8.94231 3.23597 9.20012 2.85013 9.52513 2.52513C9.85013 2.20012 10.236 1.94231 10.6606 1.76642C11.0852 1.59053 11.5404 1.5 12 1.5C12.4596 1.5 12.9148 1.59053 13.3394 1.76642C13.764 1.94231 14.1499 2.20012 14.4749 2.52513C14.7999 2.85013 15.0577 3.23597 15.2336 3.66061C15.4095 4.08525 15.5 4.54037 15.5 5H21.25C21.4489 5 21.6397 5.07902 21.7803 5.21967C21.921 5.36032 22 5.55109 22 5.75C22 5.94891 21.921 6.13968 21.7803 6.28033C21.6397 6.42098 21.4489 6.5 21.25 6.5H19.93L18.76 18.611C18.6703 19.539 18.238 20.4002 17.5477 21.0268C16.8573 21.6534 15.9583 22.0004 15.026 22H8.974C8.04186 22.0001 7.1431 21.653 6.45295 21.0265C5.7628 20.3999 5.33073 19.5388 5.241 18.611L4.07 6.5H2.75C2.55109 6.5 2.36032 6.42098 2.21967 6.28033C2.07902 6.13968 2 5.94891 2 5.75C2 5.55109 2.07902 5.36032 2.21967 5.21967C2.36032 5.07902 2.55109 5 2.75 5H8.5ZM10.5 9.75C10.5 9.55109 10.421 9.36032 10.2803 9.21967C10.1397 9.07902 9.94891 9 9.75 9C9.55109 9 9.36032 9.07902 9.21967 9.21967C9.07902 9.36032 9 9.55109 9 9.75V17.25C9 17.4489 9.07902 17.6397 9.21967 17.7803C9.36032 17.921 9.55109 18 9.75 18C9.94891 18 10.1397 17.921 10.2803 17.7803C10.421 17.6397 10.5 17.4489 10.5 17.25V9.75ZM14.25 9C14.4489 9 14.6397 9.07902 14.7803 9.21967C14.921 9.36032 15 9.55109 15 9.75V17.25C15 17.4489 14.921 17.6397 14.7803 17.7803C14.6397 17.921 14.4489 18 14.25 18C14.0511 18 13.8603 17.921 13.7197 17.7803C13.579 17.6397 13.5 17.4489 13.5 17.25V9.75C13.5 9.55109 13.579 9.36032 13.7197 9.21967C13.8603 9.07902 14.0511 9 14.25 9ZM6.734 18.467C6.78794 19.0236 7.04724 19.5403 7.46137 19.9161C7.87549 20.292 8.41475 20.5001 8.974 20.5H15.026C15.5853 20.5001 16.1245 20.292 16.5386 19.9161C16.9528 19.5403 17.2121 19.0236 17.266 18.467L18.424 6.5H5.576L6.734 18.467Z" />
  ),
  arrowUp: (
    <path d="M19.9201 15.05L13.4001 8.53001C12.6301 7.76001 11.3701 7.76001 10.6001 8.53001L4.08008 15.05" />
  ),
  arrowDown: (
    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" />
  ),
  arrowRight: (
    <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" />
  ),
  arrowLeft: (
    <path d="M14.9998 19.92L8.47984 13.4C7.70984 12.63 7.70984 11.37 8.47984 10.6L14.9998 4.07996" />
  ),
  edit: (
    <path d="M6.03984 17.625C6.08672 17.625 6.13359 17.6203 6.18047 17.6133L10.1227 16.9219C10.1695 16.9125 10.2141 16.8914 10.2469 16.8563L20.182 6.92109C20.2038 6.89941 20.221 6.87366 20.2328 6.8453C20.2445 6.81695 20.2506 6.78656 20.2506 6.75586C20.2506 6.72516 20.2445 6.69477 20.2328 6.66642C20.221 6.63806 20.2038 6.61231 20.182 6.59063L16.2867 2.69297C16.2422 2.64844 16.1836 2.625 16.1203 2.625C16.057 2.625 15.9984 2.64844 15.9539 2.69297L6.01875 12.6281C5.98359 12.6633 5.9625 12.7055 5.95312 12.7523L5.26172 16.6945C5.23892 16.8201 5.24707 16.9493 5.28545 17.071C5.32384 17.1927 5.39132 17.3032 5.48203 17.393C5.63672 17.543 5.83125 17.625 6.03984 17.625ZM7.61953 13.5375L16.1203 5.03906L17.8383 6.75703L9.3375 15.2555L7.25391 15.6234L7.61953 13.5375ZM20.625 19.5938H3.375C2.96016 19.5938 2.625 19.9289 2.625 20.3438V21.1875C2.625 21.2906 2.70937 21.375 2.8125 21.375H21.1875C21.2906 21.375 21.375 21.2906 21.375 21.1875V20.3438C21.375 19.9289 21.0398 19.5938 20.625 19.5938Z" />
  ),
  plus: (
    <>
      <path d="M6 12H18" />
      <path d="M12 18V6" />
    </>
  ),
  minus: <path d="M6 12H18" />,

  arrowGoBack: (
    <>
      <path d="M7.12988 18.3101H15.1299C17.8899 18.3101 20.1299 16.0701 20.1299 13.3101C20.1299 10.5501 17.8899 8.31006 15.1299 8.31006H4.12988" />
      <path d="M6.43012 10.8099L3.87012 8.24994L6.43012 5.68994" />
    </>
  ),

  arrowUpRight: (
    <>
      <path d="M9.42676 5.9895L18.011 5.9895L18.011 14.5738" />
      <path d="M5.99023 18.0105L17.8908 6.10989" />
    </>
  ),
  arrowForward: (
    <>
      <path d="M14.4297 5.93005L20.4997 12.0001L14.4297 18.0701" />
      <path d="M3.5 12H20.33" />
    </>
  ),
  send: (
    <>
      <path d="M7.39969 6.32003L15.8897 3.49003C19.6997 2.22003 21.7697 4.30003 20.5097 8.11003L17.6797 16.6C15.7797 22.31 12.6597 22.31 10.7597 16.6L9.91969 14.08L7.39969 13.24C1.68969 11.34 1.68969 8.23003 7.39969 6.32003Z" />
      <path d="M10.1104 13.6501L13.6904 10.0601" />
    </>
  ),
  download: (
    <>
      <path d="M9 11V17L11 15" />
      <path d="M9 17L7 15" />
      <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" />
      <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" />
    </>
  ),
  spinner: (
    <>
      <path
        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.2 12C3.2 16.8601 7.13989 20.8 12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.13989 16.8601 3.2 12 3.2C7.13989 3.2 3.2 7.13989 3.2 12Z"
        className="spinnerCont"
      />
      <path
        d="M21.8985 12.1728C22.5059 12.1834 22.9954 12.6857 22.9242 13.289C22.6967 15.2176 21.9615 17.0586 20.785 18.62C19.6085 20.1813 18.0414 21.3954 16.2502 22.1457C15.6899 22.3805 15.0721 22.0484 14.8945 21.4674C14.7169 20.8864 15.0477 20.2777 15.602 20.029C16.9508 19.4239 18.1312 18.486 19.028 17.296C19.9248 16.1059 20.501 14.7127 20.7109 13.2494C20.7971 12.648 21.2911 12.1622 21.8985 12.1728Z"
        // fill="#0F1D14"
      />
    </>
  ),
  refresh: (
    <>
      <path d="M14.8901 5.08002C14.0201 4.82002 13.0601 4.65002 12.0001 4.65002C7.21008 4.65002 3.33008 8.53002 3.33008 13.32C3.33008 18.12 7.21008 22 12.0001 22C16.7901 22 20.6701 18.12 20.6701 13.33C20.6701 11.55 20.1301 9.89002 19.2101 8.51002" />
      <path d="M16.1302 5.32L13.2402 2" />
      <path d="M16.1298 5.31995L12.7598 7.77995" />
    </>
  ),
  eventBusy: (
    <>
      <path d="M8 2V5" />
      <path d="M16 2V5" />
      <path d="M3.5 9.08997H20.5" />
      <path d="M18 23C20.2091 23 22 21.2091 22 19C22 16.7909 20.2091 15 18 15C15.7909 15 14 16.7909 14 19C14 21.2091 15.7909 23 18 23Z" />
      <path d="M19.0692 20.11L16.9492 18" />
      <path d="M19.0497 18.02L16.9297 20.14" />
      <path d="M21 8.5V16.36C20.27 15.53 19.2 15 18 15C15.79 15 14 16.79 14 19C14 19.75 14.21 20.46 14.58 21.06C14.79 21.42 15.06 21.74 15.37 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" />
      <path d="M11.9955 13.7H12.0045" />
      <path d="M8.29431 13.7H8.30329" />
      <path d="M8.29431 16.7H8.30329" />
    </>
  ),
  eventHistory: (
    <>
      <path d="M14.55 21.67C18.84 20.54 22 16.64 22 12C22 6.48 17.56 2 12 2C5.33 2 2 7.56 2 7.56M2 7.56V3M2 7.56H4.01H6.44" />
      <path d="M2 12C2 17.52 6.48 22 12 22" />
    </>
  ),
  checkMark: <path d="M20 6L9 17L4 12" />,

  envelope: (
    <>
      <path d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z" />
      <path d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9" />
    </>
  ),
  copy: (
    <>
      <path d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z" />
      <path d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z" />
    </>
  ),
  warning: (
    <>
      <path d="M12 6.75V13.5" />
      <circle cx="12" cy="16.875" r="1.125" />
      <path d="M23.0256 12C23.0256 5.9111 18.0895 0.975037 12.0006 0.975037C5.91165 0.975037 0.975586 5.9111 0.975586 12C0.975586 18.089 5.91165 23.025 12.0006 23.025C18.0895 23.025 23.0256 18.089 23.0256 12Z" />
    </>
  ),
  search: (
    <>
      <path d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z" />
      <path d="M22 22L20 20" />
    </>
  ),
  trashBin: (
    <>
      <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" />
      <path d="M9.00039 15.38H13.9204C15.6204 15.38 17.0004 14 17.0004 12.3C17.0004 10.6 15.6204 9.21997 13.9204 9.21997H7.15039" />
      <path d="M8.57 10.77L7 9.18999L8.57 7.62" />
    </>
  ),
  close: (
    <>
      <path d="M1.5 1.5L22.8627 22.5627" />
      <path d="M22.8633 1.5L1.50059 22.5627" />
    </>
  ),

  eye: (
    <>
      <path d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" />
      <path d="M11.9998 20.27C15.5298 20.27 18.8198 18.19 21.1098 14.59C22.0098 13.18 22.0098 10.81 21.1098 9.39997C18.8198 5.79997 15.5298 3.71997 11.9998 3.71997C8.46984 3.71997 5.17984 5.79997 2.88984 9.39997C1.98984 10.81 1.98984 13.18 2.88984 14.59C5.17984 18.19 8.46984 20.27 11.9998 20.27Z" />
    </>
  ),
  eyeSlash: (
    <>
      <path d="M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z" />
      <path d="M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77" />
      <path d="M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993" />
      <path d="M15.5104 12.7C15.2504 14.11 14.1004 15.26 12.6904 15.52" />
      <path d="M9.47 14.53L2 22" />
      <path d="M22.0003 2L14.5303 9.47" />
    </>
  ),
  goodStatus: (
    <>
      <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" />
      <path d="M7.75 12L10.58 14.83L16.25 9.17004" />
    </>
  ),
  hamburger: (
    <>
      <path d="M1.5 12H22.5" />
      <path d="M1.5 21H22.5" />
      <path d="M1.5 3H22.5" />
    </>
  ),
  chart: (
    <>
      <path d="M2 22H22" />
      <path d="M9.75 4V22H14.25V4C14.25 2.9 13.8 2 12.45 2H11.55C10.2 2 9.75 2.9 9.75 4Z" />
      <path d="M3 10V22H7V10C7 8.9 6.6 8 5.4 8H4.6C3.4 8 3 8.9 3 10Z" />
      <path d="M17 15V22H21V15C21 13.9 20.6 13 19.4 13H18.6C17.4 13 17 13.9 17 15Z" />
    </>
  ),
  location: (
    <>
      <path d="M10 11.1917C11.436 11.1917 12.6 10.0276 12.6 8.5917C12.6 7.15576 11.436 5.9917 10 5.9917C8.56408 5.9917 7.40002 7.15576 7.40002 8.5917C7.40002 10.0276 8.56408 11.1917 10 11.1917Z" />
      <path d="M3.01663 7.07508C4.65829 -0.141583 15.35 -0.13325 16.9833 7.08342C17.9416 11.3167 15.3083 14.9001 13 17.1168C11.325 18.7334 8.67496 18.7334 6.99163 17.1168C4.69163 14.9001 2.05829 11.3084 3.01663 7.07508Z" />
    </>
  ),
  people: (
    <>
      <path d="M9.15957 10.87C9.05957 10.86 8.93957 10.86 8.82957 10.87C6.44957 10.79 4.55957 8.84 4.55957 6.44C4.55957 3.99 6.53957 2 8.99957 2C11.4496 2 13.4396 3.99 13.4396 6.44C13.4296 8.84 11.5396 10.79 9.15957 10.87Z" />
      <path d="M16.4103 4C18.3503 4 19.9103 5.57 19.9103 7.5C19.9103 9.39 18.4103 10.93 16.5403 11C16.4603 10.99 16.3703 10.99 16.2803 11" />
      <path d="M4.15973 14.56C1.73973 16.18 1.73973 18.82 4.15973 20.43C6.90973 22.27 11.4197 22.27 14.1697 20.43C16.5897 18.81 16.5897 16.17 14.1697 14.56C11.4297 12.73 6.91973 12.73 4.15973 14.56Z" />
      <path d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14" />
    </>
  ),
  wellWishes: (
    <>
      <path d="M21.6602 10.44L20.6802 14.62C19.8402 18.23 18.1802 19.69 15.0602 19.39C14.5602 19.35 14.0202 19.26 13.4402 19.12L11.7602 18.72C7.59018 17.73 6.30018 15.67 7.28018 11.49L8.26018 7.30001C8.46018 6.45001 8.70018 5.71001 9.00018 5.10001C10.1702 2.68001 12.1602 2.03001 15.5002 2.82001L17.1702 3.21001C21.3602 4.19001 22.6402 6.26001 21.6602 10.44Z" />
      <path d="M15.0603 19.39C14.4403 19.81 13.6603 20.16 12.7103 20.47L11.1303 20.99C7.16034 22.27 5.07034 21.2 3.78034 17.23L2.50034 13.28C1.22034 9.30998 2.28034 7.20998 6.25034 5.92998L7.83034 5.40998C8.24034 5.27998 8.63034 5.16998 9.00034 5.09998C8.70034 5.70998 8.46034 6.44998 8.26034 7.29998L7.28034 11.49C6.30034 15.67 7.59034 17.73 11.7603 18.72L13.4403 19.12C14.0203 19.26 14.5603 19.35 15.0603 19.39Z" />
      <path d="M12.6396 8.53003L17.4896 9.76003" />
      <path d="M11.6602 12.4L14.5602 13.14" />
    </>
  ),
  bigDay: (
    <>
      <path d="M19.86 8.09009C19.86 8.51009 19.83 8.92009 19.78 9.31009C19.32 9.11009 18.82 9.00009 18.29 9.00009C17.07 9.00009 15.99 9.59008 15.32 10.4901C14.64 9.59008 13.56 9.00009 12.34 9.00009C10.29 9.00009 8.63 10.6701 8.63 12.7401C8.63 15.4201 10.05 17.4701 11.63 18.8601C11.58 18.8901 11.53 18.9001 11.48 18.9201C11.18 19.0301 10.68 19.0301 10.38 18.9201C7.79 18.0301 2 14.3501 2 8.09009C2 5.33009 4.21999 3.1001 6.95999 3.1001C8.58999 3.1001 10.03 3.88009 10.93 5.09009C11.84 3.88009 13.28 3.1001 14.9 3.1001C17.64 3.1001 19.86 5.33009 19.86 8.09009Z" />
      <path d="M21.9999 12.74C21.9999 17.42 17.6699 20.18 15.7299 20.84C15.4999 20.92 15.1299 20.92 14.8999 20.84C14.0699 20.56 12.7999 19.89 11.6299 18.86C10.0499 17.47 8.62988 15.42 8.62988 12.74C8.62988 10.67 10.2899 9 12.3399 9C13.5599 9 14.6399 9.58999 15.3199 10.49C15.9899 9.58999 17.0699 9 18.2899 9C18.8199 9 19.3199 9.11 19.7799 9.31C21.0899 9.89 21.9999 11.2 21.9999 12.74Z" />
    </>
  ),
  access: (
    <>
      <path d="M11.9996 14.8799C11.0896 14.8799 10.3496 14.1399 10.3496 13.2299V10.7599C10.3496 9.84989 11.0896 9.10986 11.9996 9.10986C12.9096 9.10986 13.6496 9.84989 13.6496 10.7599V13.2299C13.6496 14.1399 12.9096 14.8799 11.9996 14.8799Z" />
      <path d="M16.98 13.4699C16.78 16.0499 14.62 18.0699 12 18.0699C9.24 18.0699 7 15.8299 7 13.0699V10.9299C7 8.16993 9.24 5.92993 12 5.92993C14.59 5.92993 16.72 7.89992 16.97 10.4199" />
      <path d="M15 2H17C20 2 22 4 22 7V9" />
      <path d="M2 9V7C2 4 4 2 7 2H9" />
      <path d="M15 22H17C20 22 22 20 22 17V15" />
      <path d="M2 15V17C2 20 4 22 7 22H9" />
    </>
  ),
  couple: (
    <>
      <circle cx="6" cy="3.6001" r="2.25" />
      <circle cx="18" cy="3.6001" r="2.25" />
      <path d="M1.5 9.80278C1.5 9.30125 1.75065 8.8329 2.16795 8.5547L5.16795 6.5547C5.6718 6.2188 6.3282 6.2188 6.83205 6.5547L9.83205 8.5547C10.2493 8.8329 10.5 9.30125 10.5 9.80278V14.9654C10.5 15.4569 10.2593 15.9172 9.85559 16.1975L8.44441 17.1775C8.04074 17.4578 7.8 17.9181 7.8 18.4096V21.9C7.8 22.2314 7.53137 22.5 7.2 22.5H4.8C4.46863 22.5 4.2 22.2314 4.2 21.9V18.4096C4.2 17.9181 3.95926 17.4578 3.55559 17.1775L2.14441 16.1975C1.74074 15.9172 1.5 15.4569 1.5 14.9654V9.80278Z" />
      <path d="M16.8978 7.19406C17.4917 6.55062 18.5083 6.55062 19.1022 7.19406L19.355 7.46791C21.3771 9.65856 22.5 12.5305 22.5 15.5117V15.5117C22.5 16.1102 22.1402 16.6499 21.5878 16.8801L20.1692 17.4712C19.9456 17.5643 19.8 17.7828 19.8 18.025V21.9C19.8 22.2314 19.5314 22.5 19.2 22.5H16.8C16.4686 22.5 16.2 22.2314 16.2 21.9V18.025C16.2 17.7828 16.0544 17.5643 15.8308 17.4712L14.4122 16.8801C13.8598 16.6499 13.5 16.1102 13.5 15.5117V15.5117C13.5 12.5305 14.6229 9.65856 16.645 7.46791L16.8978 7.19406Z" />
    </>
  ),
  tablePlan: (
    <>
      <g clipPath="url(#clip0_244_8)">
        <path d="M6.75 0H0.75C0.551088 0 0.360322 0.0790176 0.21967 0.21967C0.0790176 0.360322 0 0.551088 0 0.75L0 6.75C0 6.94891 0.0790176 7.13968 0.21967 7.28033C0.360322 7.42098 0.551088 7.5 0.75 7.5H6.75C6.94891 7.5 7.13968 7.42098 7.28033 7.28033C7.42098 7.13968 7.5 6.94891 7.5 6.75V0.75C7.5 0.551088 7.42098 0.360322 7.28033 0.21967C7.13968 0.0790176 6.94891 0 6.75 0ZM6 6H1.5V1.5H6V6Z" />
        <path d="M15 0H9C8.80109 0 8.61032 0.0790176 8.46967 0.21967C8.32902 0.360322 8.25 0.551088 8.25 0.75V6.75C8.25 6.94891 8.32902 7.13968 8.46967 7.28033C8.61032 7.42098 8.80109 7.5 9 7.5H15C15.1989 7.5 15.3897 7.42098 15.5303 7.28033C15.671 7.13968 15.75 6.94891 15.75 6.75V0.75C15.75 0.551088 15.671 0.360322 15.5303 0.21967C15.3897 0.0790176 15.1989 0 15 0ZM14.25 6H9.75V1.5H14.25V6Z" />
        <path d="M23.25 0H17.25C17.0511 0 16.8603 0.0790176 16.7197 0.21967C16.579 0.360322 16.5 0.551088 16.5 0.75V6.75C16.5 6.94891 16.579 7.13968 16.7197 7.28033C16.8603 7.42098 17.0511 7.5 17.25 7.5H23.25C23.4489 7.5 23.6397 7.42098 23.7803 7.28033C23.921 7.13968 24 6.94891 24 6.75V0.75C24 0.551088 23.921 0.360322 23.7803 0.21967C23.6397 0.0790176 23.4489 0 23.25 0ZM22.5 6H18V1.5H22.5V6Z" />
        <path d="M6.75 8.25H0.75C0.551088 8.25 0.360322 8.32902 0.21967 8.46967C0.0790176 8.61032 0 8.80109 0 9L0 15C0 15.1989 0.0790176 15.3897 0.21967 15.5303C0.360322 15.671 0.551088 15.75 0.75 15.75H6.75C6.94891 15.75 7.13968 15.671 7.28033 15.5303C7.42098 15.3897 7.5 15.1989 7.5 15V9C7.5 8.80109 7.42098 8.61032 7.28033 8.46967C7.13968 8.32902 6.94891 8.25 6.75 8.25ZM6 14.25H1.5V9.75H6V14.25Z" />
        <path d="M15 8.25H9C8.80109 8.25 8.61032 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V15C8.25 15.1989 8.32902 15.3897 8.46967 15.5303C8.61032 15.671 8.80109 15.75 9 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM14.25 14.25H9.75V9.75H14.25V14.25Z" />
        <path d="M23.25 8.25H17.25C17.0511 8.25 16.8603 8.32902 16.7197 8.46967C16.579 8.61032 16.5 8.80109 16.5 9V15C16.5 15.1989 16.579 15.3897 16.7197 15.5303C16.8603 15.671 17.0511 15.75 17.25 15.75H23.25C23.4489 15.75 23.6397 15.671 23.7803 15.5303C23.921 15.3897 24 15.1989 24 15V9C24 8.80109 23.921 8.61032 23.7803 8.46967C23.6397 8.32902 23.4489 8.25 23.25 8.25ZM22.5 14.25H18V9.75H22.5V14.25Z" />
        <path d="M6.75 16.5H0.75C0.551088 16.5 0.360322 16.579 0.21967 16.7197C0.0790176 16.8603 0 17.0511 0 17.25L0 23.25C0 23.4489 0.0790176 23.6397 0.21967 23.7803C0.360322 23.921 0.551088 24 0.75 24H6.75C6.94891 24 7.13968 23.921 7.28033 23.7803C7.42098 23.6397 7.5 23.4489 7.5 23.25V17.25C7.5 17.0511 7.42098 16.8603 7.28033 16.7197C7.13968 16.579 6.94891 16.5 6.75 16.5ZM6 22.5H1.5V18H6V22.5Z" />
        <path d="M15 16.5H9C8.80109 16.5 8.61032 16.579 8.46967 16.7197C8.32902 16.8603 8.25 17.0511 8.25 17.25V23.25C8.25 23.4489 8.32902 23.6397 8.46967 23.7803C8.61032 23.921 8.80109 24 9 24H15C15.1989 24 15.3897 23.921 15.5303 23.7803C15.671 23.6397 15.75 23.4489 15.75 23.25V17.25C15.75 17.0511 15.671 16.8603 15.5303 16.7197C15.3897 16.579 15.1989 16.5 15 16.5ZM14.25 22.5H9.75V18H14.25V22.5Z" />
        <path d="M23.25 16.5H17.25C17.0511 16.5 16.8603 16.579 16.7197 16.7197C16.579 16.8603 16.5 17.0511 16.5 17.25V23.25C16.5 23.4489 16.579 23.6397 16.7197 23.7803C16.8603 23.921 17.0511 24 17.25 24H23.25C23.4489 24 23.6397 23.921 23.7803 23.7803C23.921 23.6397 24 23.4489 24 23.25V17.25C24 17.0511 23.921 16.8603 23.7803 16.7197C23.6397 16.579 23.4489 16.5 23.25 16.5ZM22.5 22.5H18V18H22.5V22.5Z" />
      </g>
      <defs>
        <clipPath id="clip0_244_8">
          <rect width="24" height="24" />
        </clipPath>
      </defs>
    </>
  ),
  dashboard: (
    <>
      <path d="M10.5 19.9V4.1C10.5 2.6 9.86 2 8.27 2H4.23C2.64 2 2 2.6 2 4.1V19.9C2 21.4 2.64 22 4.23 22H8.27C9.86 22 10.5 21.4 10.5 19.9Z" />
      <path d="M22 10.9V4.1C22 2.6 21.36 2 19.77 2H15.73C14.14 2 13.5 2.6 13.5 4.1V10.9C13.5 12.4 14.14 13 15.73 13H19.77C21.36 13 22 12.4 22 10.9Z" />
      <path d="M22 19.9V18.1C22 16.6 21.36 16 19.77 16H15.73C14.14 16 13.5 16.6 13.5 18.1V19.9C13.5 21.4 14.14 22 15.73 22H19.77C21.36 22 22 21.4 22 19.9Z" />
    </>
  ),
  gallery: (
    <>
      <path d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z" />
      <path d="M12 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V11" />
      <path d="M16.1197 5.10999C15.7897 4.06999 16.1797 2.77999 17.2597 2.42999C17.8297 2.24999 18.5397 2.39999 18.9397 2.94999C19.3197 2.37999 20.0497 2.23999 20.6197 2.42999C21.7097 2.77999 22.0997 4.06999 21.7697 5.10999C21.2497 6.74999 19.4497 7.60999 18.9497 7.60999C18.4397 7.60999 16.6497 6.76999 16.1197 5.10999Z" />
      <path d="M2.66992 18.95L7.59992 15.64C8.38992 15.11 9.52992 15.17 10.2399 15.78L10.5699 16.07C11.3499 16.74 12.6099 16.74 13.3899 16.07L17.5499 12.5C18.3299 11.83 19.5899 11.83 20.3699 12.5L21.9999 13.9" />
    </>
  ),
  coins: (
    <>
      <path d="M7.16667 10.0833C7.16667 11.2333 9.0325 12.1666 11.3333 12.1666C13.6342 12.1666 15.5 11.2333 15.5 10.0833M0.5 5.91663C0.5 7.06663 2.36583 7.99996 4.66667 7.99996C5.605 7.99996 6.47083 7.84496 7.16667 7.58329M0.5 8.83329C0.5 9.98329 2.36583 10.9166 4.66667 10.9166C5.605 10.9166 6.47 10.7616 7.16667 10.5M11.3333 8.83329C9.0325 8.83329 7.16667 7.89996 7.16667 6.74996C7.16667 5.59996 9.0325 4.66663 11.3333 4.66663C13.6342 4.66663 15.5 5.59996 15.5 6.74996C15.5 7.89996 13.6342 8.83329 11.3333 8.83329Z" />
      <path d="M0.5 2.58337V11.75C0.5 12.9 2.36583 13.8334 4.66667 13.8334C5.605 13.8334 6.47 13.6784 7.16667 13.4167M7.16667 13.4167V6.75004M7.16667 13.4167C7.16667 14.5667 9.0325 15.5 11.3333 15.5C13.6342 15.5 15.5 14.5667 15.5 13.4167V6.75004M8.83333 5.08337V2.58337" />
      <path d="M4.66667 4.66667C2.36583 4.66667 0.5 3.73333 0.5 2.58333C0.5 1.43333 2.36583 0.5 4.66667 0.5C6.9675 0.5 8.83333 1.43333 8.83333 2.58333C8.83333 3.73333 6.9675 4.66667 4.66667 4.66667Z" />
    </>
  ),
  coin: (
    <>
      <path d="M18.5 12.65V16.35C18.5 19.47 15.59 22 12 22C8.41 22 5.5 19.47 5.5 16.35V12.65C5.5 15.77 8.41 18 12 18C15.59 18 18.5 15.77 18.5 12.65Z" />
      <path d="M18.5 7.65C18.5 8.56 18.25 9.4 17.81 10.12C16.74 11.88 14.54 13 12 13C9.46 13 7.26 11.88 6.19 10.12C5.75 9.4 5.5 8.56 5.5 7.65C5.5 6.09 6.22999 4.68 7.39999 3.66C8.57999 2.63 10.2 2 12 2C13.8 2 15.42 2.63 16.6 3.65C17.77 4.68 18.5 6.09 18.5 7.65Z" />
      <path d="M18.5 7.65V12.65C18.5 15.77 15.59 18 12 18C8.41 18 5.5 15.77 5.5 12.65V7.65C5.5 4.53 8.41 2 12 2C13.8 2 15.42 2.63 16.6 3.65C17.77 4.68 18.5 6.09 18.5 7.65Z" />
    </>
  ),
  flag: <></>,
  secure: (
    <>
      <path d="M11.741 17.75h5.92c-0.09 0.08 -0.18 0.15 -0.27 0.229l-4.27 3.2c-1.41 1.05 -3.71 1.05 -5.13 0l-4.28 -3.2c-0.94 -0.7 -1.71 -2.25 -1.71 -3.42v-7.41c0 -1.22 0.93 -2.57 2.07 -3l4.98 -1.87c0.82 -0.31 2.18 -0.31 3 0l4.97 1.87c0.95 0.36 1.76 1.361 2.01 2.381H11.73c-0.22 0 -0.42 0.01 -0.61 0.01 -1.85 0.11 -2.33 0.78 -2.33 2.89v5.43c0.011 2.3 0.6 2.891 2.95 2.891" />
      <path d="M8.8 11.22h13.2" />
      <path d="M22 9.42v5.55c-0.019 2.22 -0.63 2.771 -2.94 2.771h-7.32c-2.35 0 -2.94 -0.59 -2.94 -2.9v-5.43c0 -2.1 0.48 -2.771 2.33 -2.891 0.19 0 0.39 -0.01 0.61 -0.01h7.32c2.35 0.011 2.94 0.59 2.94 2.91" />
      <path d="M11.32 15.26h1.33" />
      <path d="M14.751 15.26h3.27" />
    </>
  ),
  globe: (
    <>
      <path d="M12.001 22c5.523 0 10 -4.478 10 -10S17.524 2 12 2 2.001 6.477 2.001 12s4.478 10 10 10" />
      <path d="M8 3h1.001a28.425 28.425 0 0 0 0 18h-1.001" />
      <path d="M15 3a28.425 28.425 0 0 1 0 18" />
      <path d="M3 16V15a28.425 28.425 0 0 0 18 0v1" />
      <path d="M3 9a28.425 28.425 0 0 1 18 0" />
    </>
  ),
  star: (
    <>
      <path d="m17.289 4.14 -0.07 3.79c-0.01 0.52 0.32 1.211 0.74 1.52l2.479 1.88c1.59 1.2 1.331 2.67 -0.57 3.27l-3.229 1.01c-0.54 0.17 -1.11 0.76 -1.25 1.31l-0.77 2.94c-0.61 2.32 -2.13 2.55 -3.39 0.51l-1.76 -2.85c-0.32 -0.52 -1.08 -0.91 -1.68 -0.88l-3.34 0.17c-2.389 0.12 -3.07 -1.26 -1.51 -3.08l1.98 -2.3c0.37 -0.43 0.54 -1.23 0.37 -1.77L4.28 6.43c-0.59 -1.9 0.47 -2.95 2.359 -2.33l2.95 0.971c0.5 0.16 1.249 0.05 1.669 -0.26l3.08 -2.22c1.66 -1.2 2.99 -0.5 2.95 1.55" />
      <path d="m21.909 22 -3.03 -3.03" />
    </>
  ),
  card: (
    <>
      <path d="M19.301 7.92v5.15c0 3.079 -1.76 4.399 -4.4 4.399H6.111c-0.45 0 -0.88 -0.04 -1.28 -0.13a3.75 3.75 0 0 1 -0.71 -0.19c-1.5 -0.56 -2.41 -1.86 -2.41 -4.08V7.92c0 -3.08 1.76 -4.4 4.4 -4.4h8.79c2.24 0 3.85 0.95 4.28 3.12 0.07 0.401 0.12 0.81 0.12 1.28" />
      <path d="M22.301 10.92v5.15c0 3.08 -1.76 4.4 -4.4 4.4h-8.79c-0.74 0 -1.41 -0.101 -1.99 -0.32 -1.19 -0.44 -2 -1.35 -2.29 -2.81 0.401 0.09 0.83 0.131 1.28 0.131h8.79c2.64 0 4.4 -1.32 4.4 -4.4V7.92c0 -0.47 -0.041 -0.889 -0.12 -1.28 1.9 0.4 3.12 1.74 3.12 4.28" />
      <path d="M10.5 13.14a2.64 2.64 0 1 0 0 -5.28 2.64 2.64 0 0 0 0 5.28" />
      <path d="M4.781 8.3v4.4" />
      <path d="M16.222 8.3v4.4" />
    </>
  ),
  menu: (
    <>
      <path d="M3.009 11.22v4.49c0 4.489 1.8 6.289 6.289 6.289h5.39c4.49 0 6.29 -1.8 6.29 -6.289V11.22" />
      <path d="M12.002 12c1.83 0 3.18 -1.49 3 -3.32l-0.66 -6.68h-4.67l-0.67 6.68c-0.18 1.83 1.17 3.32 3 3.32" />
      <path d="M18.31 12c2.02 0 3.5 -1.64 3.3 -3.65l-0.28 -2.749c-0.36 -2.6 -1.361 -3.6 -3.98 -3.6h-3.05L15 9.01c0.17 1.65 1.66 2.99 3.31 2.99" />
      <path d="M5.642 12c1.65 0 3.14 -1.34 3.3 -2.99l0.22 -2.21 0.48 -4.8H6.591c-2.62 0 -3.619 1.001 -3.979 3.6l-0.27 2.75C2.141 10.36 3.621 12 5.642 12" />
      <path d="M12.001 17c-1.669 0 -2.5 0.83 -2.5 2.5v2.5h5V19.5c0 -1.67 -0.83 -2.501 -2.501 -2.501" />
    </>
  ),
  programme: (
    <>
      <path d="M7.499 4h9c0.619 0 1.17 0.019 1.66 0.09 2.63 0.289 3.34 1.53 3.34 4.91v6c0 3.38 -0.71 4.62 -3.34 4.91 -0.49 0.07 -1.04 0.09 -1.66 0.09h-9c-0.62 0 -1.17 -0.02 -1.66 -0.09C3.21 19.62 2.499 18.38 2.499 15v-6c0 -3.38 0.71 -4.62 3.34 -4.91 0.491 -0.071 1.04 -0.09 1.66 -0.09" />
      <path d="M13.5 10h3.5" />
      <path d="M6.999 15.5h10" />
      <path d="M10.095 10h0.009" />
      <path d="M7.095 10h0.009" />
    </>
  ),
  table: (
    <>
      <path d="M5.79 14.69h12.42c1.66 0 2.659 -1.31 2.23 -2.91L18.24 3.71c-0.26 -0.941 -1.27 -1.71 -2.231 -1.71H7.99c-0.96 0 -1.97 0.77 -2.22 1.7L3.57 11.77c-0.44 1.61 0.559 2.921 2.22 2.921" />
      <path d="M12 15v7" />
      <path d="M8.001 22h8" />
    </>
  ),
  lovewall: (
    <>
      <path d="M19.861 8.09c0 0.42 -0.03 0.83 -0.08 1.22A3.713 3.713 0 0 0 18.291 9a3.697 3.697 0 0 0 -2.97 1.49A3.728 3.728 0 0 0 12.341 9c-2.05 0 -3.71 1.67 -3.71 3.74 0 2.68 1.42 4.729 3 6.12 -0.05 0.03 -0.1 0.04 -0.15 0.06 -0.3 0.109 -0.8 0.109 -1.1 0 -2.59 -0.89 -8.38 -4.571 -8.38 -10.83 0 -2.76 2.22 -4.99 4.96 -4.99a4.928 4.928 0 0 1 3.97 1.99 4.958 4.958 0 0 1 3.97 -1.99c2.74 0 4.96 2.231 4.96 4.99" />
      <path d="M22.001 12.74c0 4.68 -4.33 7.44 -6.27 8.1 -0.23 0.08 -0.6 0.08 -0.83 0 -0.83 -0.28 -2.1 -0.95 -3.27 -1.98 -1.58 -1.391 -3 -3.44 -3 -6.12 0 -2.07 1.66 -3.74 3.71 -3.74 1.22 0 2.3 0.59 2.98 1.49a3.715 3.715 0 0 1 4.46 -1.18 3.735 3.735 0 0 1 2.22 3.43" />
    </>
  ),
  invite: (
    <>
      <path d="M16.994 4.375H6.994c-3.829 0 -4.9 0.919 -4.99 4.5A3.495 3.495 0 0 1 5.494 12.375a3.502 3.502 0 0 1 -3.49 3.5c0.09 3.58 1.16 4.5 4.99 4.5H16.995c4 0 5 -1.001 5 -5v-6c0 -4 -1 -5 -5 -5" />
      <path d="M8.994 4.375V7.875" />
      <path d="M8.994 16.875v3.5" />
      <path d="m15.024 9.705 0.62 1.25c0.06 0.12 0.18 0.21 0.31 0.229l1.38 0.2c0.34 0.05 0.48 0.47 0.23 0.71l-1.001 0.97a0.413 0.413 0 0 0 -0.12 0.37l0.24 1.37c0.06 0.34 -0.3 0.6 -0.6 0.44l-1.23 -0.65a0.45 0.45 0 0 0 -0.39 0l-1.23 0.649a0.413 0.413 0 0 1 -0.6 -0.44l0.24 -1.37a0.42 0.42 0 0 0 -0.12 -0.37l-0.99 -0.971a0.416 0.416 0 0 1 0.23 -0.71l1.38 -0.2a0.39 0.39 0 0 0 0.31 -0.229l0.61 -1.25c0.14 -0.31 0.58 -0.31 0.73 0" />
    </>
  ),
  catering: (
    <>
      <path d="M5 3v7" />
      <path d="M7 3v7" />
      <path d="M6 10v11" />
      <path d="M10 3h2v5a2 2 0 0 1 -2 2v11" />
    </>
  ),
  briefcase: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-briefcase-business-icon lucide-briefcase-business"
      >
        <path d="M12 12h.01" />
        <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
        <path d="M22 13a18.15 18.15 0 0 1-20 0" />
        <rect width="20" height="14" x="2" y="6" rx="2" />
      </svg>
    </>
  ),
  event: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-party-popper-icon lucide-party-popper"
      >
        <path d="M5.8 11.3 2 22l10.7-3.79" />
        <path d="M4 3h.01" />
        <path d="M22 8h.01" />
        <path d="M15 2h.01" />
        <path d="M22 20h.01" />
        <path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10" />
        <path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17" />
        <path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7" />
        <path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z" />
      </svg>
    </>
  ),
  users: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-users-round-icon lucide-users-round"
      >
        <path d="M18 21a8 8 0 0 0-16 0" />
        <circle cx="10" cy="8" r="5" />
        <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
      </svg>
    </>
  ),
  mail: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-mail-icon lucide-mail"
      >
        <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
        <rect x="2" y="4" width="20" height="16" rx="2" />
      </svg>
    </>
  ),
};
